const configKeys = [
  'KRATOS_URL',
] as const;


/*  Get a Union type matching configKeys' values (TS black magic) thanks to:
      https://melvingeorge.me/blog/convert-array-into-string-literal-union-type-typescript  */
export type ConfigKey = typeof configKeys[number];


/*  Retrieve configuration value for a given key, or error if it doesn't
    exist (no optionals needed yet).

    For now, in k8s, we get our config via ConfigMap -> config.js ->
    global CapybaraConfig object.  This allows us to change the config
    after the image has already been docker-built.

    However, for local dev using yarn start, we allow falling back to
    REACT_APP_ prefixed environment variables.  These would be great for
    production too, except that they get baked at react build time, which
    for our pipeline is during docker build, and thus too early to know our
    configuration.  */
export default function getConfigValue(key: ConfigKey)
{
  const configVal = (globalThis as any)?.CapybaraConfig[key];
  const envVal = process.env[`REACT_APP_${key}`];
  const val = configVal !== undefined ? configVal : envVal;
  if (val === undefined) {
    throw Error('Missing configuration.');
  }
  return val;
}
